import React, { useEffect, useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { IconContext } from "react-icons/lib";
import { Button } from "../../globalStyles";
import { animateScroll as scroll } from "react-scroll";
import {
  Nav,
  NavbarContainer,
  NavLogo,
  NavIcon,
  MobileIcon,
  NavMenu,
  NavItem,
  NavItemBtn,
  NavLinks,
  NavBtnLink,
  LoginIcon,
  AvatarIcon,
  NavAnchor,
} from "./NavbarStyles";
import { useNavigate, useLocation } from "react-router-dom";
import { HiOutlineUser } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { setAuthModalOpen } from "../../redux/features/authModalSlice";
import Avatar from "../Form/AvatarImage";

const Navbar = () => {
  const [show, setShow] = useState(false);
  const [background, setBackground] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.user || {});

  // console.log({ user });

  const closeMobileMenu = () => {
    if (location.pathname !== "/") {
      navigate("/", { replace: true });
    }
    setShow(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 80) {
        setBackground(true);
        return;
      }
      setBackground(false);
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const data = [
    "About",
    "Nails",
    "Beauty",
    "Facebook",
    "Contact us",
    "Booking",
  ];

  const buttonVariants = {
    hover: {
      scale: 1.05,
      color: "#fff",
      boxShadow: "0px 0px 8px white",
      transition: {
        duration: 0.3,
        yoyo: Infinity,
      },
    },
  };

  const handleAvatarClick = () => {
    navigate("/dashboard"); // Navigates to /dashboard without opening a new tab
  };

  const handleHome = () => {
    navigate("/"); // Navigates to /dashboard without opening a new tab
  };

  return (
    <IconContext.Provider value={{ color: "#fff" }}>
      <Nav background={background}>
        <NavbarContainer>
          <div
            onClick={() => navigate("/")}
            role="button"
            className="cursor-pointer mt-6"
          >
            <NavLogo>
              <NavIcon
                src="https://globalmira.s3.ap-southeast-2.amazonaws.com/diamond_full_massage.png"
                alt=""
              />
            </NavLogo>
          </div>

          {!show &&
            (!user ? (
              <LoginIcon>
                <HiOutlineUser
                  className="mr-2"
                  onClick={() => dispatch(setAuthModalOpen(true))}
                />
              </LoginIcon>
            ) : (
              <AvatarIcon>
                <div
                  onClick={handleAvatarClick}
                  className="w-10 h-10 rounded-full bg-yellowlight text-yellowdark flex items-center justify-center font-bold cursor-pointer border border-neutral-400 hover:border-main transition mr-4"
                >
                  {user?.displayName?.charAt(0)?.toUpperCase() || "U"}
                </div>
              </AvatarIcon>
            ))}

          <MobileIcon onClick={() => setShow(!show)}>
            {show ? <FaTimes /> : <FaBars />}
          </MobileIcon>

          <NavMenu onClick={() => setShow(!show)} show={show}>
            {data.map((navItem, index) => {
              const target =
                navItem === "Booking" ? "location" : navItem.toLowerCase();
              return (
                <NavItem key={index}>
                  <NavLinks
                    spy={true}
                    duration={500}
                    smooth={true}
                    exact="true"
                    offset={-80}
                    to={target}
                    onClick={closeMobileMenu}
                  >
                    {navItem}
                  </NavLinks>
                </NavItem>
              );
            })}

            <NavItemBtn>
              <div className="flex items-center">
                {" "}
                {!user ? (
                  <HiOutlineUser
                    className="mr-8"
                    onClick={() => dispatch(setAuthModalOpen(true))}
                  />
                ) : (
                  <div
                    onClick={handleAvatarClick}
                    className="w-10 h-10 rounded-full bg-yellowlight text-yellowdark flex items-center justify-center font-bold cursor-pointer border border-neutral-400 hover:border-main transition mr-4"
                  >
                    {user?.displayName?.charAt(0)?.toUpperCase() || "U"}
                  </div>
                )}{" "}
              </div>

              {/* </NavBtnLink> */}
            </NavItemBtn>
            <a
              href="https://admin.diamondnailsbeauty.co.nz/"
              className="lg:ml-8 ml-0 lg:mt-0 mt-8 text-yellowlight border border-yellowlight py-2 px-8 rounded-full hover:bg-yellowlight hover:text-yellowdark hover:font-semibold uppercase"
              target="_blank"
            >
              Admin
            </a>
          </NavMenu>
        </NavbarContainer>
      </Nav>
    </IconContext.Provider>
  );
};

export default Navbar;
